export type BannerVariant = "success" | "warning" | "error" | "none";

export const BANNER_CONFIG = {
  success: {
    variant: "success" as const,
  },
  warning: {
    variant: "warning" as const,
  },
  error: {
    variant: "error" as const,
  },
  dismissed: {
    variant: "error" as const,
  },
  none: {
    variant: "none" as const,
  },
} as const;